import { useEffect, useState } from 'react';

/** Та же граница, на которой боковое меню становится выезжающим (styles.css). */
const MOBILE_QUERY = '(max-width: 900px)';

/** Телефон или планшет в книжной ориентации — по общей границе проекта. */
export function useIsMobile(): boolean {
  const [mobile, setMobile] = useState(() => window.matchMedia(MOBILE_QUERY).matches);
  useEffect(() => {
    const mq = window.matchMedia(MOBILE_QUERY);
    const onChange = () => setMobile(mq.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);
  return mobile;
}
